import {
    Row,
    Col,
    Carousel,
    CarouselItem,
  } from 'element-ui'
  import 'element-ui/lib/theme-chalk/index.css'
  import 'element-ui/lib/theme-chalk/display.css'
  export default {
    install (Vue) {
      Vue.use(Row)
      Vue.use(Col)
      Vue.use(Carousel)
      Vue.use(CarouselItem)
    }
  }
  